/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onPublishTaskResult = /* GraphQL */ `
  subscription OnPublishTaskResult($taskId: ID!) {
    onPublishTaskResult(taskId: $taskId) {
      errorMessage
      message
      result
      sub
      taskId
    }
  }
`;
export const onPublishTaskResultFromConsole = /* GraphQL */ `
  subscription OnPublishTaskResultFromConsole($taskId: ID!) {
    onPublishTaskResultFromConsole(taskId: $taskId) {
      errorMessage
      message
      result
      sub
      taskId
    }
  }
`;
